import Transform from '@ember-data/serializer/transform';
export default class FileAttr extends Transform {
  serialize(file) {
    // When using the `FormDataSupport` adapter mixin, values of type `File` will
    // be automatically multiparted. Sending `null` will delete the file.
    // Returning `undefined` prevents the attribute from being sent at all.
    if (!(file instanceof File || file instanceof Blob) && !(file === null)) {
      return undefined;
    }
    return file;
  }
  deserialize(file) {
    return file;
  }
}